export default __webpack_public_path__ + "static/media/tablet-featured-dark.f3da71da.jpg";